import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PlatformHereLocation {
  id: string;
  label: string;
  countryCode: string;
  city?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class PlatformLocationsService {
  private readonly http = inject(HttpClient);

  /**
   * Searches HERE regions and returns unique city names for autocomplete.
   * @param query - Search text
   * @returns Observable of city names
   */
  searchCities(query: string): Observable<string[]> {
    const term = query?.trim() ?? '';
    if (!term) {
      return of([]);
    }
    const params = new HttpParams().set('query', term);
    return this.http
      .get<PlatformHereLocation[]>(`${environment.apiBaseUrl}/general/regions`, {
        params,
      })
      .pipe(
        map((results) => {
          const cities = results
            .map((item) => item.city?.trim() ?? '')
            .filter(Boolean);
          return Array.from(new Set(cities));
        })
      );
  }
}
